export const enum MessageStatus {
  loading = 'loading',
  loaded = 'loaded',
}
